<template>
  <div>
    <AtomLoadingSecondary v-show="showLoadingState"/>
    <div id="redirect"></div>

    <div v-show="Object.values(cuenta.configuracion).length">
      <form
        id="form-autoresponder"
        autocomplete="off"
        class="m-form"
        @submit.prevent="createAcademiaAutoresponder"
      >
        <h3 class="m-form-title">
          {{ `${$t('mEditionAcademyAutorespondersConnectAutoresponder.title')} ${autoresponder.nombre}` }}
        </h3>
        <div
          class="m-container-primary"
          id="params"
        >
        </div>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
        <AtomButtonSecondary
          v-if="false"
          :button-secondary="buttonSecondary.reset"
        />
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAcademyAutorespondersConnectAutoresponder',

  data () {
    return {
      academiaId: '',
      autoresponder: {},

      buttonPrimary: {
        action: this.$t('mEditionAcademyAutorespondersConnectAutoresponder.buttonPrimary'),
        class: 'margin-right-medium margin-top-medium',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        reset: {
          class: 'a-button-reset-secondary',
          component: '',
          icon: '',
          method: '',
          text: this.$t('aButtonSecondary.actions.reset'),
          type: 'reset'
        }
      },

      cuenta: {
        autoresponder: 0,
        configuracion: {},
        descripcion: ''
      },

      isValidAutoresponder: false,
      showLoadingState: true
    }
  },

  created () {
    if (this.$can('access', 'MoleculeEditionAcademyAutoresponders') && Object.values(this.$store.getters.getAcademyAutoresponder).length) {
      this.academiaId = this.$store.getters.getAcademyData.id
      this.autoresponder = this.$store.getters.getAcademyAutoresponder
      this.cuenta.autoresponder = this.$store.getters.getAcademyAutoresponder.id
    } else {
      this.$router.push(`/${this.$t('rPaths.academy')}/${this.$t('mEditionMenu.academy.autoresponders.subject')}/${this.$t('mEditionMenu.academy.autoresponders.children.selectAutoresponder.subedition')}`)
    }
  },

  mounted () {
    this.readAcademiaAutorespondersParametros()
  },

  methods: {
    createAcademiaAutoresponder () {
      this.setAutoresponderCuenta()
      if (this.isValidAutoresponder && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('academia', 'createAcademiaAutoresponder', this.cuenta, [this.academiaId])
          .then(response => {
            this.$alerts.pushAlert('mEditionAcademyAutorespondersConnectAutoresponder', 'createAcademiaAutoresponder', 'success')
            this.$router.push(`/${this.$t('rPaths.academy')}/${this.$t('mEditionMenu.academy.autoresponders.subject')}`)
            this.isValidAutoresponder = false
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAcademyAutorespondersConnectAutoresponder', 'createAcademiaAutoresponder', 'error', 'a-alert-danger')
            this.isValidAutoresponder = false
            this.buttonPrimary.sending = false
          })
      }
    },

    readAcademiaAutorespondersParametros () {
      this.$services.read('academia', 'readAcademiaAutorespondersParametros', {}, [this.cuenta.autoresponder, this.academiaId])
        .then(response => {
          if (typeof response.data === 'object') {
            let form = ''
            form += `<div class="row">`
            form += `<div class="column column-8">`
            form += `<p class="a-input-wrapper-column margin-top-small">`
            form += `<label for="descripcion">${this.$t('mEditionAcademyAutorespondersConnectAutoresponder.inputs.descripcion.label')}</label>`
            form += `<input id="descripcion" class="a-input-primary" name="descripcion" placeholder="${this.$t('mEditionAcademyAutorespondersConnectAutoresponder.inputs.descripcion.placeholder')}">`
            form += `<small id="descripcion-errormsg" class="display-none text-color-danger">${this.$t('mEditionAcademyAutorespondersConnectAutoresponder.validation.required')}</small></p></div></div>`
            response.data.campos.forEach(param => {
              form += `<div class="row">`
              form += `<div class="column column-8">`
              form += `<p class="a-input-wrapper-column">`
              form += `<label for="${param.nombre}">${param.etiqueta}</label>`
              form += `<input id="${param.nombre}" class="a-input-primary" name="${param.nombre}">`
              form += `<small id="${param.nombre}-errormsg" class="display-none text-color-danger">${this.$t('mEditionAcademyAutorespondersConnectAutoresponder.validation.required')}</small></p></div></div>`
              this.cuenta.configuracion[param.nombre] = ''
            })
            document.getElementById('params').innerHTML = form
            document.getElementById('params').addEventListener('blur', (event) => {
              if (!event.target.value) {
                document.getElementById(`${event.target.id}-errormsg`).style.display = 'block'
                document.getElementById(event.target.id).classList.add('a-input-danger')
              } else {
                document.getElementById(`${event.target.id}-errormsg`).style.display = 'none'
                document.getElementById(event.target.id).classList.remove('a-input-danger')
              }
            }, true)
          } else {
            document.getElementById('redirect').innerHTML = `<div class="a-loading-secondary"><p>${this.$t('mEditionAcademyAutorespondersConnectAutoresponder.redirect')}</p></div>`
            window.open(response.data, '_blank')
            this.$router.go(-1)
          }
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    },

    setAutoresponderCuenta () {
      for (const param in this.cuenta.configuracion) {
        this.cuenta.configuracion[param] = document.getElementById(param).value
        if (document.getElementById(param).value === '') {
          document.getElementById(`${param}-errormsg`).style.display = 'block'
          document.getElementById(param).classList.add('a-input-danger')
        }
      }

      this.cuenta.descripcion = document.getElementById('descripcion').value
      if (document.getElementById('descripcion').value === '') {
        document.getElementById('descripcion-errormsg').style.display = 'block'
        document.getElementById('descripcion').classList.add('a-input-danger')
      }

      this.isValidAutoresponder = Object.values(this.cuenta.configuracion).find(param => param === '') === undefined &&
        this.cuenta.autoresponder > 0 && this.cuenta.descripcion !== ''
    }
  }
}
</script>
